import type { ComponentPropsWithoutRef, ReactNode } from 'react';

import type { EventBehaviorProps } from '../../utils/EventBehavior';

export const COPIED_FEEDBACK_DURATION_MS = 2000;

export type CopyableTextIconPosition = 'before' | 'after';

export interface CopyableTextProps extends Omit<ComponentPropsWithoutRef<'span'>, 'children'>, EventBehaviorProps {
    text?: string;
    children?: ReactNode;
    showIcon?: boolean;
    iconPosition?: CopyableTextIconPosition;
    showTooltip?: boolean;
    onCopy?: () => void;
}
